export default __webpack_public_path__ + "static/couple-on-couch-103791b0e21f1dc484d33f96e217146a.webp";